import React, { useState } from 'react'
import subscriptions_infos from '../../../src/data/subscriptions.json'
import { Translation, useTranslation } from 'react-i18next'

function SubscriptionCards() {
    const [selectedSubscriptionIndex, setSelectedSubscriptionIndex] = useState(0)
    const { i18n } = useTranslation()
    const locale = i18n.language

    return (
        <div className="container my-5" data-aos="fade-up">
            <div className="d-flex flex-column gap-2 pb-4 mb-4 border-bottom border-light-subtle">
                <h1 className="h3 fw-semibold">
                    <Translation>{(t) => <span>{t('subscription_proposal')}</span>}</Translation>
                </h1>
            </div>
            <div className="row justify-content-center">
                {subscriptions_infos.map((subscription, index) => (
                    <div
                        key={subscription.id}
                        onClick={() => setSelectedSubscriptionIndex(index)}
                        className="col-12 col-md-6 col-lg-3 d-flex"
                        style={{ cursor: 'pointer' }}
                    >
                        <div
                            onClick={() => setSelectedSubscriptionIndex(index)}
                            className={` ${
                                selectedSubscriptionIndex === index
                                    ? 'border border-primary shadow'
                                    : 'border border-light-subtle'
                            } rounded-4 cursor-pointer d-flex`}
                        >
                            <div className="card-body p-4">
                                <h2
                                    id={`tier-${subscription.name.toLowerCase()}`}
                                    className="card-title h4 fw-semibold"
                                >
                                    {subscription.name}
                                </h2>
                                <h5 className="card-subtitle text-muted pt-3 fw-light">
                                    {locale === 'FR'
                                        ? subscription.subtitle_fr
                                        : subscription.subtitle_en}
                                </h5>
                                <div className="mt-4">
                                    <ul className="list-unstyled mb-0 divide-y divide-gray-200">
                                        {subscription.subscription_perks.map((perk, perkIndex) => (
                                            <li
                                                key={perkIndex}
                                                className="d-flex align-items-start py-2"
                                            >
                                                <svg
                                                    className="flex-shrink-0 me-2"
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 20 20"
                                                    fill="currentColor"
                                                    aria-hidden="true"
                                                >
                                                    <path
                                                        fillRule="evenodd"
                                                        d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                        clipRule="evenodd"
                                                    />
                                                </svg>
                                                <span>
                                                    {locale === 'FR'
                                                        ? perk.perk.perk_fr
                                                        : perk.perk.perk_en}
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default SubscriptionCards
